import { useContext as e } from "react";
import o from "../packages/react-sdk/node_modules/zustand/esm/shallow.js";
import t from "../utils/logger.js";
var r = "It seems like you forgot to add your component within a top level HMSRoomProvider, please refer to 100ms react docs(https://docs.100ms.live/javascript/v2/features/integration#react-hooks) to check on the required steps for using this hook.";
function s(s) {
  return function (n) {
    var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : o;
    n || t.w("fetching full store without passing any selector may have a heavy performance impact on your website.");
    var i = e(s);
    if (!i) throw new Error(r);
    return (0, i.store)(n, a);
  };
}
function n(s) {
  return function (n) {
    var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : o;
    n || t.w("fetching full store without passing any selector may have a heavy performance impact on your website.");
    var i = e(s);
    if (!i) throw new Error(r);
    var c = i.statsStore;
    return null == c ? void 0 : c(n, a);
  };
}
export { r as hooksErrorMessage, n as makeHMSStatsStoreHook, s as makeHMSStoreHook };